export default __webpack_public_path__ + "static/how-we-build-companies-3e781e5ce228fc3d8ebabf0c335bbb26.svg";